export enum NotificationDialogKind {
  Default = '',
  Error = 'error-modal',
  Warning = 'warning-modal',
  Info = 'info-modal'
}
